import BrandTabs from '@/app/[locale]/(universal)/brand/_components/BrandTabs'
import { Box, Grid, Skeleton, Stack } from '@chakra-ui/react'

const BrandSkeleton = () => {
  return (
    <Box mt={{ base: 6, lg: 0 }} px={{ base: 4, lg: 14 }}>
      <Box rounded='24px' my={4}>
        <Grid
          templateColumns={{
            base: 'repeat(2, 1fr)',
            lg: `repeat(4, 1fr)`,
          }}
          gap={4}
        >
          <Skeleton h={{ base: '46px', lg: '52px' }} rounded='12px' />
          <Skeleton h={{ base: '46px', lg: '52px' }} rounded='12px' />
          <Skeleton h={{ base: '46px', lg: '52px' }} rounded='12px' />
        </Grid>
      </Box>
    </Box>
  )

  // return (
  //   <section className='home-brands'>
  //     <div className='home-brands__grid'>
  //       {Array.from({ length: 4 }).map((_, index) => (
  //         <Stack gap={4} key={`shipper-skeleton-${index}`}>
  //           <Skeleton
  //             height='175px'
  //             className='home-brands__media'
  //             rounded={{ base: '16px', lg: '24px' }}
  //           />
  //           <Skeleton height='18px' width='80%' />
  //           <Skeleton height='18px' width='60%' />
  //         </Stack>
  //       ))}
  //     </div>
  //   </section>
  // )
}

export default BrandSkeleton
